import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./index.scss";

const DynamicPagination = ({
  data = [],
  itemsPerPage = 10,
  currentPage = 1,
  onPageChange,
  showInfo = true,
  className = "",
  ...paginationProps
}) => {
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Don't render if no data or only one page
  if (data.length === 0 || totalPages <= 1) {
    return null;
  }

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, data.length);

  const handlePageChange = (_, page) => {
    onPageChange?.(page);
  };

  return (
    <Box className={`dynamic-pagination ${className}`}>
      {showInfo && (
        <Typography variant="body2" className="pagination-info">
          Showing {startItem} to {endItem} of {data.length} entries
        </Typography>
      )}

      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        variant="outlined"
        color="primary"
        size="medium"
        showFirstButton
        showLastButton
        {...paginationProps}
      />
    </Box>
  );
};

export default DynamicPagination;
